export const REBALANCE = {
  month:"MONTH",
  week:"WEEK",
  day:"DAY",
  none:"NONE",
}